import { useUserProfileQuery } from '@coverright/data-access/enrollment';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { keycloak } from '@coverright/shared/keycloak';

export const useUserProfile = () => {
  const { data } = useUserProfileQuery({ client: enrollmentApolloClient, skip: !keycloak.authenticated });
  return data?.userProfile;
};
